export class MazeGameVariables {
  static readonly playerSpriteName = '__PLAYER';
  static readonly wallSpriteName = '__WALL';
  static readonly heartSpriteName = '__HEART';
  static readonly LivesName = 'LivesNumber';
  static readonly roadSpriteName = '__ROAD';
  static readonly BgBackSpriteName = '__BG2';
  static readonly line = '__LINE';
}
